import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'shortDate',
})
export class ShortDatePipe implements PipeTransform {
    constructor(private translate: TranslateService) {}

    options = { month: 'short', day: 'numeric', year: 'numeric' } as const;

    transform(val: string) {
        const date = new Date(val);
        return new Intl.DateTimeFormat(`${this.translate.currentLang}-CA`, this.options).format(date);
    }
}
